"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkTransferLineComplete = void 0;
const verifyCustomTransfer_1 = require("./verifyCustomTransfer");
const verifyOneWayTransfer_1 = require("./verifyOneWayTransfer");
const verifyReturnTransfer_1 = require("./verifyReturnTransfer");
const checkTransferLineComplete = async (config) => {
    switch (config.where_when_who.type) {
        case "ONE_WAY":
            if (!(0, verifyOneWayTransfer_1.verifyOneWayTransfer)(config.transfer_legs)) {
                return false;
            }
            break;
        case "RETURN":
            if (!(0, verifyReturnTransfer_1.verifyReturnTransfer)(config.transfer_legs)) {
                return false;
            }
            break;
        case "CUSTOM":
            if (!(0, verifyCustomTransfer_1.verifyCustomTransfer)(config.transfer_legs)) {
                return false;
            }
            break;
    }
    return true;
};
exports.checkTransferLineComplete = checkTransferLineComplete;
